export default __webpack_public_path__ + "static/media/s3.865a1f93.png";